import Vue from "vue";
import Router from "vue-router";
//import Home from "./views/Home.vue";
//import ChiefPilotLog from "@/views/ChiefPilotLog.vue";
//import Manifest from "@/views/Manifest.vue";
//import GeneralManagement from "@/views/GeneralManagement.vue";
//import UserManagement from "@/views/UserManagement.vue";
//import RadioLog from "@/views/RadioLog.vue";
//import PnC from "@/views/PaymentsCharges.vue";
//import RatesSettings from "@/views/RatesSettings.vue";
import SignIn from "@/components/auth/SignIn.vue";
import SignOut from "@/components/auth/SignOut.vue";
import ModuleAccessService from "@/services/access-module.service";
import JwtService from "@/services/jwt.service";

Vue.use(Router);

export default new Router({
  mode: "history",
  //base: process.env.BASE_URL,
  routes: [
    {
      path: "/insurance",
      name: "insurance",
      component: () => import("@/views/HumanResources.vue"),
      /*beforeEnter(to, from, next) {
        if (
          JwtService.getToken()
          //ModuleAccessService.getDepartmentCode() == "ADM" ||
          //ModuleAccessService.getDepartmentCode() == "ITD"
        ) {
          next()
        } else {
          next({
            name: "home",
            query: { redirectFrom: to.fullPath }
          });
        }
      },*/
      meta: { requiresAuth: true }
    },
    {
      path: "/traffic",
      name: "traffic",
      component: () => import("@/views/TrafficHome.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          path: "/traffic/harbour/vessels",
          name: "departed-vessels",
          component: () => import("@/views/traffic/harbours.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/rating/dos",
          name: "rating-dos",
          component: () => import("@/views/traffic/rating.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/delivery/dos/list",
          name: "delivery-dos",
          component: () => import("@/views/traffic/gate-out.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/delivery/dos/create",
          name: "add-do",
          component: () => import("@/views/traffic/add-do.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/dnd",
          name: "dnd",
          component: () => import("@/views/traffic/delivery_documentation.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/waver",
          name: "waver",
          component: () => import("@/views/traffic/waver.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/view-dos",
          name: "view-dos",
          component: () => import("@/views/traffic/view-dos.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/view-do",
          name: "view-do",
          component: () => import("@/views/traffic/view-do.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/rating/rate-again",
          name: "rate-again",
          component: () => import("@/views/traffic/rate-again.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/dashboard",
          name: "dash-board",
          component: () => import("@/views/traffic/dashboard.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/traffic/reports",
          name: "reports",
          component: () => import("@/views/traffic/reporting.vue"),
          meta: { requiresAuth: true }
        }
      ]
    },

    {
      path: "/clinics",
      name: "clinics",
      component: () => import("@/views/Clinic.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          path: "/chief-pilot-log",
          name: "chief-pilot-log",
          component: () => import("@/views/ChiefPilotLog.vue"), //component: ChiefPilotLog,
          beforeEnter(to, from, next) {
            //console.log(ModuleAccessService.getDepartmentCode());
            if (
              ModuleAccessService.getDepartmentCode() == "HAR" ||
              ModuleAccessService.getDepartmentCode() == "ITD"
            ) {
              next();
            } else {
              next({
                name: "home",
                query: { redirectFrom: to.fullPath }
              });
            }
          },
          meta: { requiresAuth: true }
        },
        {
          path: "/radio-log",
          name: "radio-log",
          component: () => import("@/views/RadioLog.vue"),
          beforeEnter(to, from, next) {
            if (
              ModuleAccessService.getDepartmentCode() == "HAR" ||
              ModuleAccessService.getDepartmentCode() == "ITD"
            ) {
              next();
            } else {
              next({
                name: "home",
                query: { redirectFrom: to.fullPath }
              });
            }
          },
          meta: { requiresAuth: true }
        },
        {
          path: "/manifest",
          name: "manifest",
          component: () => import("@/views/Manifest.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/reporting",
          name: "reporting",
          component: () => import("@/views/Reports.vue"),
          meta: { requiresAuth: true }
        },

        {
          path: "/general-settings",
          name: "general-settings",
          component: () => import("@/views/GeneralManagement.vue"), //GeneralManagement,
          meta: { requiresAuth: true }
        },
        {
          path: "/settings-rates",
          name: "settings-rates",
          component: () => import("@/views/RatesSettings.vue"),
          beforeEnter(to, from, next) {
            if (
              ModuleAccessService.getDepartmentCode() == "HAR" ||
              ModuleAccessService.getDepartmentCode() == "ITD"
            ) {
              next();
            } else {
              next({
                name: "home",
                query: { redirectFrom: to.fullPath }
              });
            }
          },
          meta: { requiresAuth: true }
        },
        {
          path: "/payment-charges",
          name: "payment-charges",
          component: () => import("@/views/PaymentsCharges.vue"),
          beforeEnter(to, from, next) {
            if (
              ModuleAccessService.getDepartmentCode() == "HAR" ||
              ModuleAccessService.getDepartmentCode() == "ITD"
            ) {
              next();
            } else {
              next({
                name: "home",
                query: { redirectFrom: to.fullPath }
              });
            }
          },
          meta: { requiresAuth: true }
        },
        {
          path: "/users",
          name: "user-management",
          component: () => import("@/views/UserManagement.vue"),
          beforeEnter(to, from, next) {
            if (ModuleAccessService.getDepartmentCode() == "ITD") {
              next();
            } else {
              next({
                name: "home",
                query: { redirectFrom: to.fullPath }
              });
            }
          },
          meta: { requiresAuth: true }
        }
      ]
    },
    /*  {
      path: "/chief-pilot-log",
      name: "chief-pilot-log",
      component: ChiefPilotLog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/radio-log",
      name: "radio-log",
      component: RadioLog,
      meta: {
        requiresAuth: true
      }
    }, 
    {
      path: "/payment-charges",
      name: "payment-charges",
      component: PnC,
      meta: {
        requiresAuth: true
      }
    },

    /* {
      path: "/manifest",
      name: "manifest",
      component: Manifest,
      meta: {
        requiresAuth: true
      }
    },{
      path: "/general-settings",
      name: "general-settings",
      component: GeneralManagement,
      meta: {
        requiresAuth: true
      }
    } 
    {
      path: "/settings-rates",
      name: "settings-rates",
      component: RatesSettings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/users",
      name: "user-management",
      component: UserManagement,
      meta: {
        requiresAuth: true
      }
    },*/
    {
      path: "/sign-in",
      name: "sign-in",
      component: SignIn
      //  meta: {
      //   requiresVisitor: true
      // }
    },
    {
      path: "/sign-out",
      name: "sign-out",
      component: SignOut //,
      // meta: {
      //  requiresAuth: true
      // }
    },
    {
      path: "/change-password",
      name: "change-password",
      component: () => import("@/views/users/change-password.vue")
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});
